// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"2faebb79","109":"03e97d2c","161":"8fc41337","377":"2b50a1fb","930":"41037487"}[chunkId] + ".chunk.js";
};